export default "__VITE_ASSET__5fcd80c6__"